import { render, staticRenderFns } from "./ConfiguracaoWorkflowContrato.vue?vue&type=template&id=124eeb26&scoped=true&lang=html&"
import script from "./ConfiguracaoWorkflowContrato.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoWorkflowContrato.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoWorkflowContrato.vue?vue&type=style&index=0&id=124eeb26&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124eeb26",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/configuracao/ConfiguracaoWorkflowContrato.vue
// module id = 1140
// module chunks = 28